import { buildUserAndPendingMessages } from './buildUserAndPendingMessages'
import { priorMessagesWithoutPending } from './priorMessagesWithoutPending'

export function prepareEditTurn({ tid, messages, trimmed, exchangeId, nextIndex }) {
  const priorMessages = priorMessagesWithoutPending({ [tid]: messages }, tid)
  const { userMsg, pendingId, pendingAssistant } = buildUserAndPendingMessages({
    trimmed,
    exchangeId,
    versionIndex: nextIndex,
    now: Date.now(),
  })
  const apiMessages = [...priorMessages, userMsg].map((msg) => ({
    role: msg.role,
    content: msg.text,
  }))
  return { priorMessages, userMsg, pendingId, pendingAssistant, apiMessages }
}
